const constants = {
  BookName:"Birds of Goa: Second Edition",
  FooterCred:"Bird of Goa, All rights reserved.",
  BuyBook:"Buy Book",
  PurchaseURL:"https://amzn.in/d/7uZ7yVA",
  Pause:"Pause",
  Play:"Play",
  DisableLoop:"Disable Loop",
  EnableLoop:"Enable Loop",
  RedirectHeader:"If you are not redirected to the audio page automatically, please click the link below.",
  PlaybackLink:"playback link",
  RedirectInfo:"We must reroute you to the original source since the following recording is protected by a Creative Commons non-commercial license.",
  AudioDisclaimerHeader:"Important Advisory",
  AudioDisclaimer:"Playback is for call identification only; ‘baiting’ is harmful and prohibited under India’s Wildlife Protection Act 2022.",
  webLink:"https://birdsofgoa.avocet-peregrine.com/",
  ApiUrl: process.env.REACT_APP_API_URL
}
export default constants;